<template>
  <div class="match-invite-page page">
    <!-- 顶部 -->
    <page-top></page-top>
    <!-- 头部 -->
    <Header @chooseTab="getTab" currentIndex="1"></Header>
    <!-- 主体 -->
    <main class="main">
      <section class="breadcrumb-plate">
        <div class="label">我的位置：</div>
        <breadcrumb />
      </section>

      <section class="w">
        <div class="c-top">
          <tabbar :tabData="tabList" :code="categoryId" :seccode="seccode" :subcode="subcode" @changeSecTab="changeSecTab"></tabbar>
        </div>
      </section>
      <section class="w">
        <div>
          <span class="c-title">{{currentCategory?.categoryName}}</span>
          <span class="english-name">{{currentCategory?.englishName}}</span>
        </div>
      </section>
      <section class="content w">

        <div class="c-left">
          <div class="article-content" v-html="article.articleContent"></div>
        </div>
        <div class="c-right" v-if="article.cover">
          <div class="img-wrap">
            <img class="img" :src="article.cover" alt="" />
          </div>
        </div>
      </section>
    </main>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import pageTop from "@/components/common/pageTop.vue";
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";
import Breadcrumb from "@/components/common/breadcrumb";
import Tabbar from "@/components/list/tabbar.vue";

import { getArticleById } from "@/api/home/home.js";
import { getNavItemByCode } from "@/api/common/common.js";
export default {
  name: "Policy",
  components: { pageTop, Header, Footer, Breadcrumb, Tabbar },
  data() {
    return {
      pageSize: 10, //分页数量
      pageCount: 0, //列表总数
      displayNewsList: true,

      tabList: [],
      tabTitle: "新闻中心",
      newsList: [],
      article: "",
      pageType: "", //1 文章内容，2 文章列表
      categoryId: "",
      tabcode: "",
      seccode: "",
      subcode: "",
      currentCategory: {
        categoryName: '',
        englishName: ''
      }
    };
  },
  methods: {
    //统一获取数据
    fetchData() {
      if (!this.tabcode) return;
      getNavItemByCode(this.tabcode).then((res) => {
        if (!res.data) return;
        //侧边栏列表
        this.tabList = res.data[0];
        if (this.categoryId == this.tabList.categoryCode) {
          this.currentCategory = this.tabList
        } else if (this.currentCategory.categoryName == '' && this.tabList.list) {
          this.currentCategory = this.tabList.list.find(p =>
            this.categoryId == p.categoryCode
          );
        }

      })
    },
    //获取header组件的点击事件
    getTab(data) {
      if (data && typeof data == "string") {
        this.$router.push("/" + data);
      }
    },
    // 文章信息--富文本
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return;
        this.article = res.data;
      });
    },
    //点击改变栏目
    changeSecTab(item, tab) {
      this.currentCategory = item
      console.log("item", this.currentCategory);
      console.log("tab", tab);
      let url = "?categoryId=" + item.categoryCode + "&linkType=" + item.linkType + "&tabcode=" + this.tabcode
      url = tab ? url + '&seccode=' + tab : url

      this.seccode = tab//二级标题
      this.categoryId = item.categoryCode;//当前标题
      this.subcode = item.categoryCode;//三级标题
      this.pageType = item.linkType;
      if (this.tabList.list && this.tabList.list.length > 0) {
        const targetItem = this.tabList.list.find(item => item.categoryCode == this.categoryId);

        if (this.categoryId == this.seccode && targetItem?.list?.length) {
          item = item.list[0]
          this.seccode = targetItem.categoryCode;
          this.subcode = targetItem.list[0].categoryCode;
          this.categoryId = targetItem.list[0].categoryCode;
        }
      }

      // 展示富文本
      //链接类型：1/文章详情,2/单图列表,3/图文列表,4/文本列表,5/切换详情列表
      if (item.linkType == 1) {
        this.getArticleData(item.linkUrl);
        url = "/article" + url + '&id=' + item.linkUrl
      }
      if (item.linkType == 2) {
        url = "/singleImage" + url
      }
      if (item.linkType == 3) {
        console.log(item.linkType);
      }
      if (item.linkType == 4) {
        console.log(item.linkType);
      }
      if (item.linkType == 5) {
        console.log(item.linkType);
      }
      this.$router.push({
        path: url,
      });
    }
  },
  created() {
    this.pageType = this.$route.query?.linkType;
    let id = this.$route.query?.id;
    this.categoryId = this.$route.query?.categoryId;
    this.tabcode = this.$route.query?.tabcode;
    this.seccode = this.$route.query?.seccode;
    this.fetchData();
    if (id != "null" && id) return this.getArticleData(id);
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb__inner.is-link,
/deep/ .el-breadcrumb__inner.is-link:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__separator,
/deep/ .el-breadcrumb__separator:hover {
  color: #fff;
}
/deep/ .el-breadcrumb__item:last-child .el-breadcrumb__inner,
/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #fff;
}

.match-invite-page {
  .main {
    flex: 1;
    padding-bottom: 80px;
    background-color: #ffffff;
    margin-top: 60px;

    .breadcrumb-plate {
      background: linear-gradient(to top, #347cd0 0%, #62a3f0 100%);
      color: #fff;

      display: flex;
      align-items: center;
      padding: 16px 0;
      padding-left: 180px;

      .label {
        line-height: 1;
        font-size: 14px;
      }
    }

    .c-title {
      font-size: 28px;
      padding-left: 17px;
      border-left: 3px solid rgb(12, 108, 228);
      font-weight: 700;
    }
    .english-name {
      color: rgb(153, 153, 153);
      margin-left: 10px;
    }
    .content {
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      margin-top: 30px;
      margin-bottom: 100px;

      .c-top {
        display: flex;
        justify-content: center;
      }

      .c-left {
        flex: 2;
        display: flex;
        justify-content: center;
        background-color: #fff;

        padding-bottom: 70px;

        .picture {
          img {
            width: 280px;
            height: 280px;
          }

          p {
            padding-top: 20px;
            padding-left: 20px;
            font-size: 14px;
            color: #8d8d8d;
          }
        }
      }
      .c-right {
        flex: 1;
        margin-left: 40px;
        .img-wrap {
          img {
            max-width: 100%; /* 最大宽度不超过容器的宽度 */
            max-height: 100%; /* 最大高度不超过容器的高度 */
            object-fit: contain; /* 保持图片的宽高比 */
          }
        }
      }
    }
  }
}
</style>
